import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["fileinput", "form", "submit"];

  connect() {
    // hide file input and submit
    this.fileinputTarget.style.display = 'none';
    this.submitTarget.style.display = 'none';

    // add event listeners
    this.fileinputTarget.addEventListener('change', this.changeHandler.bind(this));
  }

  disconnect() {
    this.fileinputTarget.removeEventListener('change', this.changeHandler.bind(this));
  }

  clickHandler(event) {
    event.preventDefault();
    this.fileinputTarget.click();
  }

  changeHandler(event) {
    event.preventDefault();
    if (this.fileinputTarget.files.length > 0) {
      this.submitTarget.click();
    }
  }
}
